var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCarretLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1213 2.12132C22.5118 2.51184 22.5118 3.14501 22.1213 3.53553L6.45584 19.201C6.06532 19.5915 6.06532 20.2247 6.45584 20.6152L22.1213 36.2807C22.5118 36.6712 22.5118 37.3044 22.1213 37.6949L20.7071 39.1091C20.3166 39.4996 19.6834 39.4996 19.2929 39.1091L2.2132 22.0294C1.04163 20.8579 1.04163 18.9584 2.2132 17.7868L19.2929 0.707107C19.6834 0.316583 20.3166 0.316583 20.7071 0.707107L22.1213 2.12132Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarretLeft);
export default __webpack_public_path__ + "static/media/icon_carret-Left.ceb94999916ceeaec744e8f4848de266.svg";
export { ForwardRef as ReactComponent };